/**
 * Shared availability-expiration rules (same as the original AvailabilityPanel):
 * availability is confirmed for 1 month from talent_availability_confirmed_at,
 * and is "expiring" during its last 5 days.
 */

export const EXPIRING_SOON_DAYS = 5;

export const getAvailabilityExpirationDate = (user) => (
    user?.talent_availability_confirmed_at
        ? TB.moment(user.talent_availability_confirmed_at).add(1, 'month')
        : null
);

export const getAvailabilityStatus = (user) => {
    const expirationDate = getAvailabilityExpirationDate(user);
    const isExpired = !user?.talent_availability_confirmed_at || !user?.hasConfirmedAvailabilityForOpportunities?.();
    const daysUntilExpiry = expirationDate ? expirationDate.diff(TB.moment(), 'days') : null;
    const isExpiring = !isExpired && !!expirationDate && daysUntilExpiry <= EXPIRING_SOON_DAYS && daysUntilExpiry >= 0;

    return { expirationDate, isExpired, isExpiring, daysUntilExpiry };
};
